import * as React from "react";
import { Outlet } from "react-router-dom";
import { useParams } from "react-router-dom";
import AdminHeader from "./components/AdminHeader";
import AdminSidebar from "./components/AdminSidebar";

export default function Admin() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const params = useParams();

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div style={{
      position: 'relative',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    }}>
      {/* Independent Header */}
      <AdminHeader 
        onToggleMenu={handleToggleMenu} 
        isMenuOpen={isMenuOpen}
      />

      {/* Independent Sidebar */}
      <AdminSidebar 
        isOpen={isMenuOpen} 
        onClose={handleCloseMenu}
      />

      {/* Main Content */}
      <main style={{
        marginTop: '64px',
        padding: '32px',
        minHeight: 'calc(100vh - 64px)',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        position: 'relative',
        zIndex: 1,
      }}>
        {params["*"] === "" && (
          <div style={{
            textAlign: 'center',
            padding: '60px 40px',
            backgroundColor: 'white',
            borderRadius: '20px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            border: '1px solid rgba(88, 102, 173, 0.1)',
            maxWidth: '700px',
            margin: '0 auto',
            alignSelf: 'center',
            flex: 'none',
          }}>
            <div style={{ 
              fontSize: '64px', 
              marginBottom: '24px',
              background: 'linear-gradient(135deg, #5866ad 0%, #37b0cf 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>⚡</div>
            <h2 style={{
              color: '#333',
              fontSize: '28px',
              fontWeight: '700',
              marginBottom: '12px',
              letterSpacing: '0.5px',
            }}>
              Panel de Administración
            </h2>
            <p style={{
              color: '#666',
              fontSize: '18px',
              margin: '0',
              lineHeight: '1.6',
              maxWidth: '400px',
              margin: '0 auto',
            }}>
              Selecciona una opción del menú lateral para comenzar a gestionar la plataforma
            </p>
          </div>
        )}
        
        <Outlet />
      </main>
    </div>
  );
}